
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liff/invite",
      function () {
        return require("private-next-pages/liff/invite.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liff/invite"])
      });
    }
  